module.exports = __webpack_public_path__ + "static/media/1SmallStep.2fe38c43.png";